import { type TableHeaderRow } from '@shared/table-generator';

import { getCellBaseStyle } from './utils';

export function getColumns(courses: readonly string[]) {
  const coursesLength = courses.length;

  return [
    {
      children: [
        {
          id: 'exam-distribution-table-day',
          children: 'Day',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('52px'),
        },
        {
          id: 'exam-distribution-table-date',
          children: 'Date',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('60px'),
        },
        {
          id: 'exam-distribution-table-time',
          children: 'Time',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('104px'),
        },
        {
          id: 'exam-distribution-table-reg',
          children: 'Reg',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('56px'),
        },
        {
          id: 'exam-distribution-table-type',
          children: 'Type',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('56px'),
        },
        {
          id: 'exam-distribution-table-exam-center-code',
          children: 'ศูนย์สอบ',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('84px'),
        },
        {
          id: 'exam-distribution-table-round',
          children: 'Round',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('60px'),
        },
        {
          id: 'exam-distribution-table-location',
          children: 'Location',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('140px'),
        },
        {
          id: 'exam-distribution-table-courses',
          children: 'หลักสูตรที่เปิดสอบ',
          align: 'center',
          rowSpan: 1,
          colSpan: coursesLength,
          sx: {
            width: '100%',
          },
        },
        {
          id: 'exam-distribution-table-more-action',
          children: '',
          align: 'center',
          rowSpan: 2,
          sx: getCellBaseStyle('48px'),
        },
      ],
    },
    {
      children:
        courses.length > 0
          ? courses.map((course) => {
              return {
                children: course,
                align: 'center',
                sx: getCellBaseStyle('76px'),
              };
            })
          : [
              {
                children: '-',
                align: 'center',
                sx: getCellBaseStyle('76px'),
              },
            ],
    },
  ] as TableHeaderRow[];
}
